export default defineNuxtPlugin((nuxtApp) => {
    nuxtApp.$router.options.scrollBehavior = async (to, from, savedPosition) => {
        if (to.path !== from.path && process.client) {
            window.scrollTo({ top: 0, behavior: 'smooth' })
        }
    };
});